import en from "./translations/en/translation.json.js";
import es from "./translations/es/translation.json.js";
const resources = {
  en: {
    omega: en
  },
  es: {
    omega: es
  }
};
export {
  resources };
//# sourceMappingURL=dist/locales/index.js.map